<template>
  <div class="theme-selector_tsr" :class="{ [curTheme]: true }">
    <button class="tsr_el tsr_el--b"
      @mouseenter="showActive"
      @mouseleave="resetActive"
      @click="setActive('theme-b')"
      :class="{ active: curTheme === 'theme-b' }"/>
    <button class="tsr_el tsr_el--w"
      @mouseenter="showActive"
      @mouseleave="resetActive"
      @click="setActive('theme-w')"
      :class="{ active: curTheme === 'theme-w' }"/>
    <div class="tsr_bar"></div>
  </div>
</template>

<script>
import { TweenMax, Power1 } from 'gsap/TweenMax';

export default {

  methods: {

    showActive(e) {
      const bar = this.$el.querySelector('.tsr_bar');
      const newPos = e.target.offsetLeft;
      TweenMax.to(bar, 0.2, { left: newPos, ease: Power1.easeOut });
    },

    resetActive() {
      const bar = this.$el.querySelector('.tsr_bar');
      const activeEl = this.$el.querySelector('.tsr_el.active');
      const newPos = activeEl.offsetLeft;
      TweenMax.to(bar, 0.2, { left: newPos, ease: Power1.easeOut });
    },

    setActive(themeName) {
      this.$store.commit('theme/setCurTheme', themeName);
    },

  },
};
</script>

<style lang="scss">
@import "../styles/common/main";

.theme-selector_tsr {
  display: inline-block;
  @include clearfix;
  position: relative;

  .tsr_el {
    width: 40px;
    height: 40px;
    display: block;
    float: left;
    cursor: pointer;
    position: relative;
    &:before {
      content: '';
      width: 16px;
      height: 16px;
      display: block;
      position: absolute;
      left: 50%;
      top: 4px;
      margin-left: -8px;
      @include border-radius(50%);
    }
    &:after {
      content: '';
      width: 100%;
      left: 0;
      position: absolute;
      bottom: 0;
      height: 1px;
    }
    &.tsr_el--b {
      &:before {
        background: #555;
      }
    }
    &.tsr_el--w {
      &:before {
        background: #e1e1e1;
      }
    }
  }

  .tsr_bar {
    width: 50%;
    position: absolute;
    bottom: 0;
    height: 1px;
  }

  &.tsr--pure-colors {
    .tsr_el {
      &.tsr_el--b {
        &:before {
          background: #000;
        }
      }
    }
    .tsr_el--w {
      &:before {
        background: #fff;
      }
    }
    .tsr_bar {
      background: #000;
    }
  }

  // Black theme
  &.theme-b {

    .tsr_el {
      &:before {
        border-color: #d2d2d2;
      }
      &:after {
        background: #3f3f3f;
      }
    }

    .tsr_bar {
      background: #fff;
    }

  }

  // White theme
  &.theme-w {

    .tsr_el {
      &.tsr_el--b {
        &:before {
          background: #000;
        }
      }
      &.tsr_el--w {
        &:before {
          background: #d2d2d2;
        }
      }
      &:after {
        background: #ddd;
      }
    }

    .tsr_bar {
      background: #000;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeSelector.vue